<script>
	import fedp from '$lib/images/fedp.svg';
	import fedn from '$lib/images/fedn.svg';
	import { fade, slide, fly } from 'svelte/transition';
	import { env as public_env } from '$env/dynamic/public';
	import { onMount } from 'svelte';
	import { variables } from '$lib/variables';
	import Gallery from './Gallery.svelte';
	import { browser } from '$app/environment';

	let Swiper;
	let swiper;
	let currentIndex = 1;
	let totalSlides = 1;

	onMount(async () => {
		// @ts-ignore
		const module = await import(
			'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.esm.browser.min.js'
		);
		Swiper = module.default;

		swiper = new Swiper('.swiper', {
			direction: 'horizontal',
			loop: true,

			slidesPerView: 1, // Display 4 slides at the same time
			on: {
				slideChange: () => {
					currentIndex = swiper.realIndex + 1;
				}
			}
		});

		const prevButton = document.querySelector('.swiper-button-prevv');
		const nextButton = document.querySelector('.swiper-button-nextt');

		prevButton.addEventListener('click', () => {
			swiper.slidePrev();
		});

		nextButton.addEventListener('click', () => {
			swiper.slideNext();
		});
		totalSlides = swiper.slides.length;
	});
	export let images;


	let openGallery = false;
</script>

<svelte:head>
	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css" />
</svelte:head>
{#if browser}
	{#if openGallery}
		<Gallery {images} />
	{/if}
{/if}
<div class="w-full flex justify-center">
	<div class="flex w-[40%] justify-between items-center">
		<button on:click={() => swiper.slidePrev()} class="swiper-button-prevv"
			><img src={fedp} alt="" /></button
		>

		<span class="text-[16px] text-custom-black">{currentIndex}/{totalSlides}</span>
		<button on:click={() => swiper.slideNext()} class="swiper-button-nextt"
			><img src={fedn} alt="" /></button
		>
	</div>
</div>
<!-- Slider main container -->
<div class="swiper">
	<!-- Additional required wrapper -->
	<div class="swiper-wrapper">
		<!-- Slides -->
		{#each images as item}
			<div class="swiper-slide">
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<img
					on:click={() => {
						openGallery = false;
						setTimeout(() => {
							openGallery = true;
						}, 150);
					}}
					style="width: 100%; height: auto;"
					src="{item.image}"
					alt=""
				/>
			</div>
		{/each}
	</div>
	<!-- If we need pagination -->

	<!-- If we need navigation buttons -->

	<!-- If we need scrollbar -->
	<div class="swiper-scrollbar hidden" />
</div>

<!-- <div class="swiper-button-prev"><img src={fedp} alt="" /></div>
<div class="swiper-button-next"><img src={fedn} alt="" /></div> -->

<style>
	.swiper {
		width: 100%;
		height: auto;
		position: relative;
		z-index: 1;
	}
	.swiper-slide {
		justify-content: center;
		display: flex;
	}
	/* .swiper-button-next, .swiper-button-prev {
  position: absolute;
  top: 10px; 
} */
	.swiper-button-next::after {
		display: none;
	}
	.swiper-button-prev::after {
		display: none;
	}
</style>
